<p class="fw-bold fs-5 ms-2 my-2">{{ displayLabel() }}</p>

<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [titleHeader]="'breadcrumbs.smart-tool-tips.edit' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.SMART_TOOL_TIPS_LIST_FORM"
        [itemTypeId]="Constants.CONSTANT_PERMISSIONS.MANDATORY"
        [enableAdd]="false"
        [enableDeleteAction]="false"
        [isLocalData]="true"
        [localData]="data()"
        [tableInputs]="tableInputs()"
        (actionClicked)="getAction($event)"
        (inputListChanged)="onTableDataChanged($event)"
    ></adaa-data-table>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [saveButtonTitle]="'common.form.button.submit' | translate"
        [cancelButtonTitle]="'common.form.button.cancel' | translate"
        (cancelClicked)="close()"
        (saveClicked)="submit()"
    ></adaa-form-action-buttons>
</div>

<adaa-smart-tooltips-info-editor-modal #info (info)="setInfo($event)"></adaa-smart-tooltips-info-editor-modal>
